/**
 * BLOCK: FAQ - Child
 */
import React, { useState, useEffect, lazy, Suspense } from 'react';
import lazyLoader from '@Controls/lazy-loader';

let prevState;

const Settings = lazy(() =>
	import(/* webpackChunkName: "chunks/faq-child/settings" */ './settings')
);
const Render = lazy(() =>
	import(/* webpackChunkName: "chunks/faq-child/render" */ './render')
);

const WPSPFaqChildEdit = (props) => {
	const initialState = {
		isFocused: 'false',
	};

	const [state, setStateValue] = useState(initialState);

	useEffect(() => {
		// Replacement for componentDidMount.

		// Assigning block_id in the attribute.
		props.setAttributes({ block_id: props.clientId.substr(0, 8) });
		// Pushing Style tag for this block css.
		prevState = props.isSelected;
	}, []);

	useEffect(() => {
		// Replacement for componentDidUpdate.

		if (!props.isSelected && prevState && state.isFocused) {
			setStateValue({
				isFocused: 'false',
			});
		}
		if (props.isSelected && !prevState) {
			setStateValue({
				isFocused: true,
			});
		}
		prevState = props.isSelected;
	}, [props]);

	return (
		<>
			<Suspense fallback={lazyLoader()}>
				<Render state={state} parentProps={props} />
				<Settings />
			</Suspense>
		</>
	);
};

export default WPSPFaqChildEdit;
